/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import Meeting from '@/models/meeting';
import { ReactionChangeChangeData } from '../../hooks/stompResponse/reactionChange';
import { user } from '@/models';
import HandupEmoJ from './components/HanupEmoJ/index';
export enum HandUpStatus {
  on = 1,
  off = 2,
}
interface EmoJProps {
  meeting?: Meeting;
  emojUrl?: boolean;
  boxWidth: number;
  boxHeight: number;
  yxuid: string;
}
const EmoJ: React.FC<EmoJProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { meeting, boxWidth, boxHeight, yxuid } = props;
    const minTop = Math.min(boxWidth, boxHeight) * 0.03;
    const emoWidth = 20 * Math.log(Math.min(boxWidth, boxHeight)) - 60;
    const [emoJData, setEmoJData] = useState<ReactionChangeChangeData | null>();
    const timeoutRef = useRef<any>();

    const handDown = () => {
      if (emoJData?.isHandup === HandUpStatus.on) {
        if (emoJData.memberUid === user.uid) {
          API.client.reaction.selfHandDown
            .request({}, { channelId: meeting?.info?.channelId })
            .then((res) => {});
        }
      }
    };
    useEffect(() => {
      const info = meeting?.reactionData[yxuid];
      if (info) {
        setEmoJData(info);
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        if (info.emoticonAnimationWebp) {
          timeoutRef.current = window.setTimeout(() => {
            meeting?.updateRectionMap(yxuid, null);
          }, info?.emoticonAnimationWebpDuration);
        }
      } else {
        setEmoJData(null);
      }
    }, [meeting?.reactionData[yxuid], yxuid]);

    if (
      (!emoJData?.emoticonAnimationWebp && !emoJData?.isHandup) ||
      emoJData.isHandup === HandUpStatus.off
    ) {
      return null;
    }
    return (
      <div className={s.emojWrapper} style={{ top: minTop, left: minTop }}>
        {emoJData?.isHandup === HandUpStatus.on ? (
          <HandupEmoJ style={{ width: emoWidth, height: emoWidth }} onClick={handDown}></HandupEmoJ>
        ) : (
          <img
            src={emoJData?.emoticonAnimationWebp}
            className={s.icon}
            style={{ width: emoWidth, height: emoWidth }}
          />
        )}
      </div>
    );
  })
);
export default EmoJ;
